const knownHeaders = [
    {
        "headerName": "SiteName",
        "headerType": "string",
        "maxLength": 32,
        "validateRegex": true
    },
    {
        "headerName": "timeZone",
        "headerType": "string",
        "validateRegex": false
    },
    {
        "headerName": "scheduledReportTime",
        "headerType": "string",
        "validateRegex": false
    },
    {
        "headerName": "EmailSubscribed",
        "headerType": "boolean",
        "validateRegex": false
    },
    {
        "headerName": "emailList",
        "headerType": "string",
        "validateRegex": false
    },
    {
        "headerName": "snapshotReportCategories",
        "headerType": "string",
        "validateRegex": false
    },
    {
        "headerName": "attachCSV",
        "headerType": "boolean",
        "validateRegex": false
    }
]

export const IPAddressHeaders = [    {
    "headerName": "startIPAddress",
    "headerType": "string",
    "validateRegex": false
},
{
    "headerName": "endIPAddress",
    "headerType": "string",
    "validateRegex": false
}]

export const SitesConfigData = {
    "maxLineLimit": 25001,
    "maxFileSize": 10,
    "headerMismatchErrorMsg": "Specified headers dont match",
    "maxRowsErrorMsg": "Max number of rows allowed is ",
    "existingSitenameErrorSites": "existingSitenameErrorSites",
    "matchFileType": true,
    "checkDataType": true,
    "matchHeader": true,
    "rowMisMatchError": "Error on row",
    "knownObj": knownHeaders
}

export const SitesConfigDataWithIP = {...SitesConfigData, knownObj:knownHeaders.concat(IPAddressHeaders)}
